import React from "react";
import { Platform, View, Text, StyleSheet } from "react-native";
import FontFamily from "../../constants/fonts";
import MobileDatePicker from "./MobileDatePicker";
import WebDatePicker from "./WebDatePicker";

interface LhDatePickerProps {
  label?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  value?: Date | null;
  onChange?: (date: Date | null) => void;
  placeholder?: string;
  minimumDate?: Date;
  maximumDate?: Date;
  labelStyle?: any;
  iconColor?: string;
  disabledIconColor?: string;
  [key: string]: any; // allows passing additional props to the picker
}

const LhDatePicker = (props: LhDatePickerProps) => {
  const {
    label,
    error,
    helperText,
    disabled,
    value,
    onChange,
    placeholder,
    minimumDate,
    maximumDate,
    labelStyle,
    iconColor,
    disabledIconColor,
    ...restProps
  } = props;

  const handleDateChange = (date: Date | null) => {
    if (onChange) {
      onChange(date);
    }
  };

  // Determine which picker to use based on platform
  const Wrapper = Platform.OS === "web" ? WebDatePicker : MobileDatePicker;

  return (
    <View style={{ width: "100%" }}>
      {label && (
        <Text style={[styles.label, error && styles.errorText, labelStyle]}>{label}</Text>
      )}
      <Wrapper
        value={value || null}
        onChange={handleDateChange}
        placeholder={placeholder}
        minimumDate={minimumDate}
        maximumDate={maximumDate}
        error={error}
        disabled={disabled}
        iconColor={iconColor}
        disabledIconColor={disabledIconColor}
        {...restProps}
      />
      {!!helperText && (
        <Text style={[styles.helperText, error && styles.errorText]}>
          {helperText}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    fontSize: 12,
    marginBottom: 8,
    color: "#2D2D2D",
    fontWeight: "400",
    fontFamily: FontFamily.regular,
  },
  helperText: {
    fontSize: 12,
    color: "#4B4B4B",
    marginTop: 4,
    fontFamily: FontFamily.regular,
  },
  errorText: {
    color: "#dc3545",
  },
});

export default LhDatePicker;
